import { GetDefaultCurrentFrameIndex } from "./types";

export const getDefaultCurrentFrameIndex: GetDefaultCurrentFrameIndex = ({
  cameraFrames,
  targetFrame,
}) => {
  if (!cameraFrames || !targetFrame) return 0;

  return (
    cameraFrames.findIndex((frame) => frame.frameName === targetFrame) || 0
  );
};
